import React from 'react';
import {ConnectedAbilities} from './Abilities';
import {ConnectedApprovals} from './Approvals';
import {PageHeader, PageTitle} from '@cjdev/visual-stack/lib/components/PageHeader';
import PageContent from '@cjdev/visual-stack/lib/components/PageContent';

const AccessPage = () => {
    return (
        <React.Fragment>
            <PageHeader>
                <PageTitle>Access</PageTitle>
            </PageHeader>
            <PageContent>
                <ConnectedApprovals />
                <ConnectedAbilities />
            </PageContent>
        </React.Fragment>
    );
};

export {AccessPage};



// WEBPACK FOOTER //
// ./src/view/AccessPage/index.js